import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import * as api from '@src/utils/mmc-api/api.js';
import { navigate } from 'gatsby';

const QuestionBankGuard = () => {
  const { data: subscribed, isLoading } = useQuery({
    queryKey: ['question-bank-subscription'],
    queryFn: api.questionBankMe,
    // Refetch every 2 minutes
    refetchInterval: 1000 * 60 * 2,
    // Refetch on window focus
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    // if subscribed or loading, do nothing
    if (subscribed || isLoading) {
      return;
    }

    // not subscribed
    navigate('/subscriptions');
  }, [subscribed, isLoading]);

  return null;
};

export default QuestionBankGuard;
